@let prices = item().prices;

<mat-card [class.disabled]="disabled()" [class.selected]="isInBundle()" class="wrapper-bundle-card" (click)="onAddToBundle()">
  <div class="wrapper-image">
    <ui-product-labels
      [displayVertically]="true"
      [product]="item()"
      [groups]="['product-badges']"
      class="badge-labels-grid"
    ></ui-product-labels>

    @if (item().images.length) {
      <img [alt]="item().images[0].large" [src]="item().images[0].large">
    }
  </div>

  <div class="wrapper-content">
    <span [matTooltip]="item().details.name" class="product-name">{{ item().details.name }}</span>

    <div class="wrapper-attributes">
      <span>VE: {{ item().details.packagingUnit }}</span>

      @if (isFree()) {
        <span class="free-label">GRATIS</span>
      } @else {
        <span>Art.-Nr.: {{ item().sku }}</span>

        @if (prices && !prices.redacted) {
          <span>VK: <ui-product-prices-formatter [showThousandthsPlace]="true" [price]="prices.singleUnit"></ui-product-prices-formatter></span>
        }
      }
    </div>

    <div class="wrapper-actions">
      @if (showAddToBundle()) {
        <ui-add-to-cart-small-element
          (add)="onAddToBundle()"
          (amountChange)="amount.set($event)"
          [amount]="amount()"
          (remove)="removeFromBundle.emit(item())"
          [disabled]="disabled()"
          [quantityChangeDebounceMs]="0"
          [quantityMax]="disabled() ? maxQuantity() : undefined"
          [quantityMin]="1"
          [isInCart]="isInBundle()"
        >
        </ui-add-to-cart-small-element>
      }

      @if (showItemQuantity()) {
        <ui-quantity-counter class="round" [disabled]="true" [value]="item().quantity"></ui-quantity-counter>
      }
    </div>

  </div>
</mat-card>
